import { UserSuggestion, UserSuggestionResponse } from './usersTypes';

export function parseUsers(users: UserSuggestionResponse[]): UserSuggestion[] {
  return users.map(parseUser);
}

export function parseUser(user: UserSuggestionResponse): UserSuggestion {
  const {
    id,
    registered,
    display_name,
    image_id,
    user_name,
    email,
    online,
    blacklisted,
    whitelisted
  } = user;

  return {
    id,
    isRegistered: registered,
    displayName: display_name,
    imageId: image_id,
    username: user_name,
    email,
    isOnline: online,
    isBlacklisted: blacklisted,
    isWhitelisted: whitelisted
  };
}
